import FallGuysAlternative from './fallguysalternative'

export default FallGuysAlternative